module.exports = __webpack_public_path__ + "img/like.1f825578.svg";